module.exports = __webpack_public_path__ + "static/media/covi_wel_cap.e42d7813.png";